import * as R from 'ramda'
import Cookie from 'js-cookie'
import config from 'config'

let sessionSocket
const pendingSocketEvents = []
const pendingEventRegistrations = []

const eventFns = {
  setSocketId(data) {
    sessionSocket.id = data.socketId
    R.map(payload => socketSend(payload), pendingSocketEvents)
  }
}

export const socketOn = (eventType, cb) => {
  // Queue the registration if socket isn't ready yet
  if (!sessionSocket) {
    pendingEventRegistrations.push({ eventType, cb })
    return
  }

  eventFns[eventType] = cb
}

const flushPendingRegistrations = () => {
  while (pendingEventRegistrations.length > 0) {
    const { eventType, cb } = pendingEventRegistrations.shift()
    eventFns[eventType] = cb
  }
}

export const socketOff = (eventType, cb) => {
  // Remove from pending registrations if socket isn't ready yet
  if (!sessionSocket) {
    const idx = pendingEventRegistrations.findIndex(
      reg => reg.eventType === eventType && reg.cb === cb
    )
    if (idx !== -1) {
      pendingEventRegistrations.splice(idx, 1)
    }
    return
  }

  if (eventFns[eventType] === cb) {
    delete eventFns[eventType]
  }
}

export function socketSend(payload) {
  if (!sessionSocket || sessionSocket.readyState !== 1) {
    pendingSocketEvents.push(payload)
  } else {
    sessionSocket.send(JSON.stringify(payload))
  }
}

/**
 * Close the socket connection and clear module state. Call on logout so the
 * server receives the disconnect and can broadcast userOffline.
 */
export const closeSocket = () => {
  if (sessionSocket) {
    sessionSocket.close()
    sessionSocket = null
  }
  pendingSocketEvents.length = 0
  pendingEventRegistrations.length = 0
  for (const key of Object.keys(eventFns)) {
    if (key !== 'setSocketId') {
      delete eventFns[key]
    }
  }
}

export const makeSocket = hasSession => {
  if (
    config.NEXT_PUBLIC_SOCKET_SERVER_URL &&
    hasSession &&
    !sessionSocket &&
    typeof window !== 'undefined'
  ) {
    sessionSocket = new WebSocket(config.NEXT_PUBLIC_SOCKET_SERVER_URL)

    sessionSocket.addEventListener('message', function (m) {
      const event = JSON.parse(m.data)
      const { action, data } = event
      const fn = eventFns[action]
      if (fn) {
        fn(data)
      }
    })

    sessionSocket.addEventListener('open', function () {
      // Register any event listeners that were queued before socket was ready
      flushPendingRegistrations()

      socketSend({
        action: 'login',
        data: { userSession: Cookie.get(config.NEXT_PUBLIC_COOKIE_NAME) }
      })
    })
  }
  return sessionSocket
}
